import React from 'react'
import { Helmet } from 'react-helmet'
import logo from '../../../../theme/images/logo.svg'
import { Card, Layout, LayoutHeader, LayoutBody, ForgotPasswordForm } from '../../../components'
import styles from './ForgotPasswordPage.module.scss'

const ForgotPasswordPage = () => {
  return (
    <div className={styles.root}>
      <Helmet>
        <title>reOS | Forgot password</title>
      </Helmet>
      <Layout>
        <LayoutHeader>
          <div className={styles.header}>
            <img width="96px" src={logo} alt="reOS" />
          </div>
        </LayoutHeader>
        <LayoutBody>
          <div className={styles['form-container']}>
            <Card on style={{ width: '360px' }}>
              <ForgotPasswordForm />
            </Card>
          </div>
        </LayoutBody>
      </Layout>
    </div>
  )
}

export default ForgotPasswordPage
